import { render, staticRenderFns } from "./CourseAdministration.vue?vue&type=template&id=231e082e&scoped=true&"
import script from "./CourseAdministration.vue?vue&type=script&lang=js&"
export * from "./CourseAdministration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231e082e",
  null
  
)

export default component.exports